<div class="At-Sidebar At-SidebarComment At-CustomScroll">
    <div class="At-SidebarShareTop">
      <div class="At-CloseSidebar" (click)="close()"> <i class="icon-cancel"></i></div>
      <div class="At-SidebarShareTopInner">
        <figure class="At-FigureTop">
          <img src="assets/images/posts/post-img6.jpg" class="img-fluid" alt="">
        </figure>
        <div class="form-group mb-0">
          <textarea class="form-control At-PlainInput" placeholder="Say something ..."
            id="exampleFormControlTextarea1" rows="1"></textarea>
        </div>
      </div>
    </div>
    <!-- At-SidebarShareTop ends  -->
    <div class="At-SidebarShareMiddle">
      <div class="At-SidebarShareMiddleInner">
        <div class="form-group mb-5">
          <input class="form-control At-InputSearch" type="text" placeholder="Search">
        </div>
        <div class="At-SidebarShareBtns">
          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex ">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex ">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex ">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex ">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex ">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex ">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex ">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

          <div class="At-InfoBox">
            <div class="At-InfoImg">
              <figure>
                <img src="assets/images/profile/profile-small6.png" class="img-fluid " alt="">
                <div class="At-badgePurple"><i class="icon-bage"></i></div>
              </figure>
            </div>
            <div class="At-InfoTitle d-flex ">
              <div class="At-TitleLeft">
                <h5>Anatoli • <span class="At-TextRed">matt</span></h5>
                <h6>Last Seen 12:09am</h6>
              </div>
              <div class="At-ShareBtn">
                <button><i class="icon-send"></i> Send</button>
              </div>
            </div>
          </div>
          <!-- At-InfoBox ends  -->

        </div>
      </div>
    </div>
    <!-- At-SidebarShareMiddle ends  -->

  </div>
